export const SESSION_LOCAL_STORAGE_KEY ="sessionId"